import * as React from "react";
import injectSheet from "react-jss";

const styleSheet = (theme: any) => ({
  container: {
    padding: "1em",
  },
  error: {
    ...theme.error,
    color: "black",
    fontSize: 22,
    textTransform: "initial",
    opacity: 0,
    display: "block",
    "@media (max-width: 900px)": {
      paddingLeft: "10px",
    },
  },
});

interface ClassProp {
  error: string;
}

interface ErrorProps {
  classes?: ClassProp | any;
  show?: boolean;
  title?: string;
  message: string;
}

const GeneralError: React.FC<ErrorProps> = (props: ErrorProps) => {
  const { classes, show, title, message } = props;
  // prevents error spacing on mobile //
  let errorDisplay = "none";
  if (show) errorDisplay = "block";

  return (
    <div className={classes.container} data-testid="container">
      <h1 className={classes.h1} data-testid="title">
        {title}
      </h1>
      <div
        className={classes.error}
        style={{
          opacity: show ? 1 : 0,
          display: errorDisplay,
        }}
        data-testid="message"
      >
        {message}
      </div>
    </div>
  );
};

GeneralError.defaultProps = {
  title: "Error",
  show: true,
  classes: null,
};

export default injectSheet(styleSheet)(GeneralError);
